import { render } from "./DeepLink.vue?vue&type=template&id=0afb68f2&scoped=true&ts=true&lang=pug"
import script from "./DeepLink.vue?vue&type=script&lang=ts"
export * from "./DeepLink.vue?vue&type=script&lang=ts"

import "./DeepLink.vue?vue&type=style&index=0&id=0afb68f2&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./DeepLink.vue?vue&type=custom&index=0&blockType=i18n&locale=en"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locale/es/views/deepLink.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Ftarball%2Fsrc%2Fviews%2FDeepLink%2FDeepLink.vue&locale=es"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0afb68f2"]])

export default __exports__